import React from "react";

export default function EmptyState() {
  return (
    <div className="lo-empty">
      <h3>No orders match this filter</h3>
      <p>Try changing filters or clearing search.</p>
    </div>
  );
}
